import { Name } from './name.page';

export { Name };
